import React, { useCallback } from 'react';
import "../../styles/chats/chats.css";
import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { firebaseAuth } from "../firebase/firebase_configuration";
import { firebaseFirestore } from "../firebase/firebase_configuration";
import SearchForUser from "./search_for_user";
import DisplayChats from "./display_chats";

import noChatsImage from "../../images/chats/no_chats_image.png";

const Chats = () => {
    const [getCurrentUserId, setCurrentUserId] = useState("");
    const [getHasMessages, setHasMessages] = useState(true);
    const [isUserSearchDialog, setUserSearchDialog] = useState(false);
    const [getMessageTabDetails, setMessageTabDetails] = useState([]);

    const onUserSearch = () => {
        setUserSearchDialog(true);
    };

    const retrieveUserUsername = async (userId) => {
        try {
            const userRef = doc(firebaseFirestore, "User Details", userId);
            const userSnapshot = await getDoc(userRef);
          
            if (userSnapshot.exists()) {
                return userSnapshot.data().username || "";
            } else {
                console.log('User document does not exist.');
                return "";
            }
        } catch (error) {
            console.log(`${error.message}`);
            return "";
        }
    }

    const retrieveUserUserImage = async (userId) => {
        try {
            const userRef = doc(firebaseFirestore, "User Details", userId);
            const userSnapshot = await getDoc(userRef);
          
            if (userSnapshot.exists()) {
                return userSnapshot.data().image || "";
            } else {
                console.log('User document does not exist.');
                return "";
            }
        } catch (error) {
            console.log(`${error.message}`);
            return "";
        }
    }

    const retrieveAllChats = useCallback(async () => {
        try {
            const userRef = doc(firebaseFirestore, "User Details", getCurrentUserId);
            const userSnapshot = await getDoc(userRef);
          
            if (userSnapshot.exists()) {
                const chats = userSnapshot.data().chats || [];
                if (chats.length <= 0) {
                    setHasMessages(false);
                }else{
                    setHasMessages(true);
                    let allMessages = [];
                    for (let chatEntry of chats) {
                        const id = Object.keys(chatEntry).toString();
                        const val = Object.values(chatEntry).toString();
                        const username = await retrieveUserUsername(id);
                        const image = await retrieveUserUserImage(id);
                        const listMessa = [id, username, image, val];
                        allMessages.push(listMessa);
                    }

                    for (let i = 0; i < allMessages.length; i++) {
                        const messagesRef = doc(firebaseFirestore, 'User Chats', allMessages[i][3]);
            
                        onSnapshot(messagesRef, (docSnapshot) => {
                            if (docSnapshot.exists()) {
                                const chatData = docSnapshot.data();
                                let messagesArray = [];
                                Object.keys(chatData).forEach((fieldName) => {
                                    if (fieldName.startsWith("message")) {
                                        const message = chatData[fieldName][0];
                                        const timestamp = parseInt(fieldName.replace('message', ''), 10);
                                        messagesArray.push({ ...message, timestamp });
                                    }
                                });
            
                                messagesArray.sort((a, b) => a.timestamp - b.timestamp);
                                if (messagesArray.length > 0) {
                                    let lastMessage = "";
                                    if (messagesArray[messagesArray.length - 1].content != null) {
                                        lastMessage = messagesArray[messagesArray.length - 1].content;
                                    } else if (messagesArray[messagesArray.length - 1].content_image != null) {
                                        lastMessage = "Image sent"
                                    } else {
                                        lastMessage = "No message sent"
                                    }
                                    allMessages[i][4] = lastMessage;
                                    setMessageTabDetails(allMessages);
                                }
                            }
                        });
                    }
                }
            } else {
                console.log('User document does not exist.');
            }
        } catch (error) {
            console.log(`${error.message}`);
        }
    }, [getCurrentUserId]);

    useEffect(() => {
        const getUser = onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setCurrentUserId(user.uid);
            }
        });
            
        return () => getUser();
    }, []);

    useEffect(() => {
        if (getCurrentUserId !== "") {
            retrieveAllChats();
        }
    }, [getCurrentUserId, retrieveAllChats]);

    return(
        <div>
            {
                !getHasMessages
                    ? <div className="no_chats_screen">
                        <img alt='no chats' src={noChatsImage} className="no_chats_available_img" />
                        <p className="no_chats_header">Messages</p>
                        <p className="no_chats_text">Your conversations will appear here.</p>
                        <p className="no_chats_link" onClick={() => onUserSearch()}>Start a conversation</p>
                        {isUserSearchDialog && <SearchForUser isSearchShow={isUserSearchDialog} setSearchShow={setUserSearchDialog} />}
                    </div>
                    : <div className="chats_screen">
                        <div className="chats_screen_search" onClick={() => onUserSearch()}>
                            search
                        </div>
                        {isUserSearchDialog && <SearchForUser isSearchShow={isUserSearchDialog} setSearchShow={setUserSearchDialog} />}

                        <div className="chats_list">
                            {
                                getMessageTabDetails.map((msg, index) => {
                                    return(
                                        <DisplayChats key={index} displayConUserImage={msg[2]} displayConUsername={`@${msg[1]}`} displayLastMessage={msg[4]} id={msg[0]} />
                                    );
                                })
                            }
                        </div>
                    </div>
            }
        </div>
    );
};

export default Chats;